import { EmailTemplate } from './types';

const getters = {
  getEmailTemplateById:
    state =>
    (id: string): EmailTemplate | {} => {
      const emailTemplates = state.emailTemplates?.filter(emailTemplate => emailTemplate.id === id) || [];
      return emailTemplates[0] || {};
    }
};

export default getters;
